import { AutogenModelEdiStandardCodeLookupRaw, AutogenRowEdiStandardCodeLookupRaw } from "./autogen/AutogenModelEdiStandardCodeLookupRaw";

export class ModelEdiStandardCodeLookupRaw extends AutogenModelEdiStandardCodeLookupRaw<RowEdiStandardCodeLookupRaw> {
	constructor() {
		super(RowEdiStandardCodeLookupRaw);
	}
}

export class RowEdiStandardCodeLookupRaw extends AutogenRowEdiStandardCodeLookupRaw {
}